import {ChangeDetectorRef, Component, Input, OnChanges} from '@angular/core';
import {BenchmarkPercentile} from '../../../shared/benchmark-types';
import {SortingCriterion} from '../../../shared/models';
import {Page} from '../../../shared/helpers';
import {NgRedux} from '@angular-redux/store';
import {BaseColumn, IAppState, INITIAL_STATE} from '../../../store/IAppState';
import * as _ from 'lodash';
import {Variable} from '../../../variable-container/variable-container.component';
import {DataTableColumns} from '../../../shared/data-table-columns';
import {AppAction, denialsChosenTabChangedTo, multiLevelDenialsChangedTo} from '../../../store/actions';
import {MultilevelTab, MultilevelTabCollections} from '../../../shared/enums';
import {DrillDownService} from '../../../services/drilldown.service';
import {DenialsMultiLevelEntity} from '../../denials-models';

@Component({
  selector: 'app-denials-provider-page',
  templateUrl: './denials-provider-page.component.html',
  styleUrls: ['./denials-provider-page.component.scss']
})
export class DenialsProviderPageComponent implements OnChanges {
  @Input() fromPdfExport = false;
  @Input() benchmarkPercentile: BenchmarkPercentile;
  @Input() denialsMultiLevel: DenialsMultiLevelEntity[];
  @Input() nodePath: string;
  @Input() isCustom: boolean;
  @Input() variables: Variable[];
  @Input() showVariableMenu: boolean;
  @Input() canHideCPTsDeniedModal = false;
  @Input() activeVarianceToggle = false;
  @Input() columns: DataTableColumns[];
  @Input() originalColumns: DataTableColumns[];
  @Input() updateSortingCriteria: (sortingCriteria: SortingCriterion | undefined) => void;
  @Input() displayedColumns: DataTableColumns[] = [];
  @Input() reducerAction: (multiLevelByNodePathDenialsColumns: BaseColumn[]) => AppAction;
  showProgressBar: boolean;
  isDepartment = false;
  isSpecialty = false;
  currentPage = Page.DenialsProvider;
  sortingDataAccessor: any;
  defaultSortColumn = 'denialRate';
  nodePathName = '';

  constructor(
    private ngRedux: NgRedux<IAppState>,
    private _changeDetectorRef: ChangeDetectorRef,
    private drillDownService: DrillDownService
  ) { }

  ngOnChanges(): void {
    this.showProgressBar =
      _.isEqual(this.denialsMultiLevel, INITIAL_STATE.data.denialsByMultiLevelData.providerDenials);
    this.sortingDataAccessor = (data: any, sortHeaderId: string) => {
      return (sortHeaderId === 'denialRate') ? data[this.defaultSortColumn] : data[sortHeaderId];
    };
  }

  levelSpecificHandleSortChange = (denialsEntries: DenialsMultiLevelEntity[]) => {

    this.ngRedux.dispatch(multiLevelDenialsChangedTo({
      ...this.ngRedux.getState().data.denialsByMultiLevelData,
      providerDenials: denialsEntries
    }));
  };

  whenProviderSelected = (selectedNode: DenialsMultiLevelEntity) => {
    if (!selectedNode) {
      return;
    }
    this.drillDownService.drillDownIntoNode(selectedNode.providerNodePath, this.nodePath, MultilevelTab.BY_PROVIDER);
    this.ngRedux.dispatch(denialsChosenTabChangedTo(MultilevelTabCollections.BY_PAYER));
  };
}
